export default __webpack_public_path__ + "static/media/user-icon.884afe26.svg";